import AboutUs from '../modules/about';

import withViewEvent from '../modules/common/utils/tracking/withViewEvent';
import { K_AMPLITUDE_EVENT_VIEW_ABOUT } from '../modules/common/libs/amplitude/events';

export default withViewEvent(AboutUs, K_AMPLITUDE_EVENT_VIEW_ABOUT);
